import VideoCard from "../Cards/VideoCard";
import React from "react";
import { ConferenceContext } from "../../index";
import clsx from "clsx";


const LayoutPinned = (props: any) => {
  const conference = React.useContext(ConferenceContext);

  const pinnedParticipant = conference.videoTrackAssignments.find((e: any) => (e.streamId === props.pinnedParticipant?.streamId) );
console.log("first pinned participant",pinnedParticipant,conference.videoTrackAssignments, props.pinnedParticipant)
  const MAX_VIDEO_AT_SIDE = 4;

  //conference.updateMaxVideoTrackCount(Math.min(conference.globals.desiredMaxVideoTrackCount, MAX_VIDEO_AT_SIDE));

  const showOthers = Object.keys(conference.allParticipants).length > MAX_VIDEO_AT_SIDE + 1; //one video is pinned

  let playingParticipantsCount = 0;

  //if we need to show others card, then we don't show the last video to hold place for the others card
  const maxPlayingParticipantsCount = showOthers ? MAX_VIDEO_AT_SIDE - 1 : Math.min(conference.videoTrackAssignments.length, MAX_VIDEO_AT_SIDE);
  const playingParticipants: any[] = [];

  const pinnedVideo = () => {
    let pinnedParticipantName;
    if (pinnedParticipant !== undefined) {
      playingParticipants.push(conference.videoTrackAssignments.find((e: any) => e.streamId === pinnedParticipant.streamId));
      pinnedParticipantName = conference?.allParticipants[pinnedParticipant.streamId]?.name;
    }
    const audioTrack = conference.audioTracks.filter((x: any) => x.id.replace("audio","") == pinnedParticipant.videoLabel.replace("video",""))
    return (
      pinnedParticipant ? (
        <div
          key="PINNEDREMOTEVIDEO"
           className={clsx("w-[100%] h-[100%]")}
        >
          <div
            className={clsx("shadow-sm h-[100%] w-[100%] bg-black")}
          >
            <VideoCard
              trackAssignment={pinnedParticipant}
              audioTrackAssignment={audioTrack}
              autoPlay
              name={
                pinnedParticipantName
              }
              pinned
              onHandlePin={() => {
                conference.pinVideo(
                  pinnedParticipant.streamId
                );
              }}
              id={pinnedParticipant.streamId}
            />
          </div>
        </div>
      ) : null
    )
  }

  const videoCards = () => {
    return (
      <div className="w-[100px] h-[100px] absolute top-2 right-2 space-y-2">
        {
          // eslint-disable-next-line
          conference.videoTrackAssignments.map((element: any, index: number) => {
            let isPlayOnly;
if(element?.streamId==conference.roomName && element?.videoLabel == conference.publishStreamId)
  return <></>
            try {
              isPlayOnly = JSON.parse(conference?.allParticipants[element?.streamId]?.metaData)?.isPlayOnly;
            } catch (e) {
              isPlayOnly = false;
            }
            const strId = element?.streamId == conference.roomName ? element.videoLabel : element.streamId
            const participantName = conference?.allParticipants[strId]?.name;

            if (participantName === "" || typeof participantName === 'undefined' || isPlayOnly || participantName === "Anonymous") {
              return null;
            }
            if (element?.streamId !== pinnedParticipant?.streamId && playingParticipantsCount < maxPlayingParticipantsCount) {
              playingParticipantsCount++;
              playingParticipants.push(element);

              const audioTrack = conference.audioTracks.filter((x: any) => x.id.replace("audio","") == element?.videoLabel?.replace("video",""))

              return (
                <div
                  className={clsx("shadow-sm rounded-lg h-[100%] bg-black"
                  )}
                  key={index}
                >
                  <VideoCard
                    trackAssignment={element}
                    audioTrackAssignment={audioTrack}
                    autoPlay
                    name={participantName}
                    onHandlePin={() => { 
                      conference.pinVideo(element.streamId);
                    }}
                    id={`${participantName}`} />

                </div>
              );
            }
          })}
      </div>
    );
  }

  const othersCard = () => {
    return (
      <>
        {showOthers ? (
          <div className="unpinned">
            <div className="single-video-container  others-tile-wrapper">
              Others...
              {/* <OthersCard
          playingParticipants = {playingParticipants}
        /> */}
            </div>
          </div>
        ) : null
        }
      </>
    );
  }

  return (
    <>
      {pinnedVideo()}
      <div id="unpinned-gallery">
        {/* {conference?.videoTrackAssignments.length === 0 ? <p>There is no active publisher right now.</p> : null} */}
        {videoCards()}
        {process.env.REACT_APP_LAYOUT_OTHERS_CARD_VISIBILITY === 'true' ? othersCard() : null}
      </div>
    </>
  );
};

export default LayoutPinned;
